import "@/App.css";

import HeroSection from "@/components/home/HeroSection";
import HeroStats from "@/components/home/HeroStats";
import WhyChooseSection from "@/components/home/WhyChooseSection";
import ProductCategories from "@/components/home/ProductCategories";
import ManufacturingSection from "@/components/home/ManufacturingSection";
import IndustriesSection from "@/components/home/IndustriesSection";
import GallerySection from "@/components/home/GallerySection";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import FAQSection from "@/components/home/FAQSection";
import ContactSection from "@/components/home/ContactSection";

import Marquee from "@/components/Marquee";

export default function Home() {
  return (
    <div data-testid="home-page">
      <HeroSection />
      <Marquee />
      <WhyChooseSection />
      <ProductCategories />
      <ManufacturingSection />
      <IndustriesSection />
      <GallerySection />
      <TestimonialsSection />
      <FAQSection />
      <ContactSection />
    </div>
  );
}